import { render, staticRenderFns } from "./tuckOrderLogDialog.vue?vue&type=template&id=cdf432c8&"
import script from "./tuckOrderLogDialog.vue?vue&type=script&lang=js&"
export * from "./tuckOrderLogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdf432c8')) {
      api.createRecord('cdf432c8', component.options)
    } else {
      api.reload('cdf432c8', component.options)
    }
    module.hot.accept("./tuckOrderLogDialog.vue?vue&type=template&id=cdf432c8&", function () {
      api.rerender('cdf432c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/tuckOrderLogDialog.vue"
export default component.exports